import ServiceExec from '@/common/utils/ServiceExec';
import { flyer } from '@/common/service/apiList';
import store from '@/store';

export default {
  // 260619: AI 전단지 생성 (후보 N장, base64 data URL) — 동기(레거시)
  aiGenerate: async ({ commit }, formData) => {
    const { status, data } = await ServiceExec.multiPost(flyer.aiGenerate, formData);
    if (status !== ServiceExec.status.OK) return [];
    return data ?? [];
  },

  // 260622/260625: 비동기 생성 시작 → {jobId, sessionId, remaining}. 실패 시 null.
  aiGenerateStart: async ({ commit }, formData) => {
    const { status, data } = await ServiceExec.multiPost(flyer.aiGenerateAsync, formData);
    if (status !== ServiceExec.status.OK) return null;
    return data && data.jobId ? data : null;
  },

  // 260625: AI 전단지 생성권 잔액 {hasActiveSession, sessionId, remaining}
  aiBalance: async () => {
    const { status, data } = await ServiceExec.get(flyer.aiBalance);
    if (status !== ServiceExec.status.OK) return { hasActiveSession: false, sessionId: null, remaining: 0 };
    return data ?? { hasActiveSession: false, sessionId: null, remaining: 0 };
  },

  // 260622: 생성 상태 폴링 → { status: GENERATING|DONE|FAILED, candidates?, error? }
  aiGenerateStatus: async ({ commit }, { jobId }) => {
    const userNo = store.getters['user/getUserData']?.userNo;
    if (!userNo || !jobId) return { status: 'FAILED', error: '' };
    const { status, data } = await ServiceExec.get(flyer.aiGenerateStatus(userNo, jobId));
    // BE ServiceException(잡 없음/만료 등)=HTTP500+평문 → FAILED로 전환
    if (status !== ServiceExec.status.OK) return { status: 'FAILED', error: typeof data === 'string' ? data : '' };
    return data || { status: 'GENERATING' };
  },

  // 전단지 저장 (선택 후보 → tblFile FLYER_IMAGE)
  saveFlyer: async ({ commit }, formData) => {
    const { status, data } = await ServiceExec.multiPost(flyer.save, formData);
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  // 내 전단지 목록
  getMyFlyers: async ({ commit }) => {
    const userNo = store.getters['user/getUserData']?.userNo;
    if (!userNo) return;
    const { status, data } = await ServiceExec.get(flyer.getMyFlyers(userNo));
    if (status !== ServiceExec.status.OK) return;
    commit('setMyFlyers', data ?? []);
  },

  // 전단지 삭제
  deleteFlyer: async ({ commit }, { fileNo, userNo }) => {
    const { status } = await ServiceExec.delete(flyer.deleteFlyer(fileNo, userNo));
    return status === ServiceExec.status.OK;
  },

  // 260619 P2: 전단지 발송 — 관심 카테고리 매칭 소비자 서랍에 in-app 적재
  sendFlyer: async ({ commit }, { fileNo, businessCategoryNos, radiusKm }) => {
    const userNo = store.getters['user/getUserData']?.userNo;
    if (!userNo) return { ok: false };
    const { status, data } = await ServiceExec.post(flyer.send(fileNo, userNo, businessCategoryNos, radiusKm));
    if (status === ServiceExec.status.OK) return { ok: true };
    // BE ServiceException = HTTP 500 + 메시지 평문(data) → 그대로 노출(일일 1회 제한 등)
    return { ok: false, message: typeof data === 'string' ? data : (data && data.message) || '' };
  },

  // 260630 D: 발송 전 타깃 프리뷰. {radiusKm, nearbyMembers, interestedMembers, interestedPct, hasLocation}. 실패 시 null.
  getFlyerReach: async (_ctx, { radiusKm }) => {
    try {
      const { status, data } = await ServiceExec.get(flyer.reach(radiusKm));
      if (status !== ServiceExec.status.OK) return null;
      return data ?? null;
    } catch (e) { return null; }
  }
};
